<div class="rounded-xl overflow-hidden border min-w-[200px] bg-third-level p-4">
  <div class="flex items-start justify-between">
    <div class="flex flex-col">
      <span class="text-xs">
        {{ title() || (cardTitle() | transloco) }}
      </span>

      <span class="font-bold mt-2 text-xl" [ngClass]="iconColor()">
        {{ formattedValue() }}
      </span>
    </div>

    <div
      class="pl-3 pr-3 pt-2 pb-2 rounded-lg"
      [ngClass]="iconColor()"
      [style.backgroundColor]="'color-mix(in srgb, currentColor 9%, transparent)'"
    >
      <i [class]="icon()"></i>
    </div>
  </div>
</div>
